module.exports = __webpack_public_path__ + "static/old-gnawbone-mtg_afr-cdc463a25a5c7e391eaec874e69a8160.jpg";